define('main.js',['require','Promise','jquery','owl-carousel','./blocks/features/features','./blocks/tariffs/tariffs','./js/stat','./js/ph','../common/js/utm','./blocks/header/header','./blocks/banner/banner','../common/blocks/tariff/tariff','./blocks/about/about','../cloud-new/js/xray'],function(require) {
    'use strict';

    require('Promise');
    require('jquery');
    require('owl-carousel');
    require('./blocks/features/features');
    require('./blocks/tariffs/tariffs');
    require('./js/stat');
    require('./js/ph');
    require('../common/js/utm');
    require('./blocks/header/header');
    require('./blocks/banner/banner');
    require('../common/blocks/tariff/tariff');
    require('./blocks/about/about');
    var xray = require('../cloud-new/js/xray');

    xray.sendPromoXray('open', '', 'old');
});

